import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

import { store, persistor } from "./store"
import { PersistGate } from "redux-persist/integration/react"
import { ToastProvider } from "ToastStore"
import { CartProvider } from "context/cartContext"
import { WishlistProvider } from "context/wishlistContext"
import { SystemConfigurationProvider } from "context/systemConfigContext"
const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.Fragment>
        <BrowserRouter>
          <ToastProvider>
            <SystemConfigurationProvider>
            <CartProvider>
              <WishlistProvider>
                <App />
              </WishlistProvider>
            </CartProvider>
            </SystemConfigurationProvider>
          </ToastProvider>
        </BrowserRouter>
      </React.Fragment>
    </PersistGate>
  </Provider>
)

serviceWorker.unregister()
